/*TODO: Figure out why datasource.maxRowLimiter has to be set in constructor of some of the objects that use ep-max-row-warning work.
         See task-search-page.component, document-search-page.componente
         In other objects the setting within the max row warning component is sufficient
*/

import { Component, Input } from '@angular/core';
import { Datasource } from '@Core/services/proprietary/datasource';

@Component({
    standalone: false,
    selector: 'ep-max-row-warning',
    template: `
    <sm-alert
      *ngIf="
        datasource &&
        datasource.maxRowLimiter &&
        [datasource.tranNode && datasource.tranNode.Count] == datasource.maxRows
      "
      type="warning"
    >
      More than {{ datasource.maxRows }} rows were found and the results have been limited. Please refine the criteria
      and search again.
    </sm-alert>
  `
})
export class MaxRowWarningComponent {
    @Input()
    datasource: Datasource;

    constructor() { }

    ngAfterViewInit() {
        window.setTimeout(
            () => (this.datasource.maxRowLimiter = true),
            10
        ); /* timeout is a hack to get around a change detection error in angular dev mode */
    }
}

///*(click)="model.maxLimiter='false'; dsEntity.criteria.Max=''; dsEntity.refresh()" ngbTooltip="Click here to retrieve all results"*/
